export default __webpack_public_path__ + "static/media/contribution-icon.48069fc0.svg";